import { render, staticRenderFns } from "./Masker3.vue?vue&type=template&id=5341a21e&scoped=true"
import script from "./Masker3.vue?vue&type=script&lang=js"
export * from "./Masker3.vue?vue&type=script&lang=js"
import style0 from "./Masker3.vue?vue&type=style&index=0&id=5341a21e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341a21e",
  null
  
)

export default component.exports